import React, { useEffect, useState, createContext, useContext } from 'react';
import { ThemeName, Language, ThemeContextValue, ThemeTokens } from '../types/theme';
import { themeTokens } from '../constants/themeTokens';
import nlCommon from '../../locales/nl/common.json';
import enCommon from '../../locales/en/common.json';
const translations: Record<string, any> = {
  nl: nlCommon,
  en: enCommon
};
const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);
interface ThemeProviderProps {
  children: React.ReactNode;
}
export function ThemeProvider({
  children
}: ThemeProviderProps) {
  const [theme, setThemeState] = useState<ThemeName>(() => {
    const saved = localStorage.getItem('mvl-theme');
    if (saved === 'dark' || saved === 'light') return saved as ThemeName;
    return 'dark';
  });
  const [language, setLanguageState] = useState<Language>(() => {
    const saved = localStorage.getItem('mvl-language');
    return saved as Language || 'nl';
  });
  const setTheme = (newTheme: ThemeName) => {
    setThemeState(newTheme);
    localStorage.setItem('mvl-theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem('mvl-language', lang);
  };
  const getThemeClasses = (): ThemeTokens => {
    return themeTokens[theme];
  };
  const t = (key: string): string => {
    const keys = key.split('.');
    let value: any = translations[language];
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key;
      }
    }
    return typeof value === 'string' ? value : key;
  };
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, []);
  const value: ThemeContextValue = {
    theme,
    setTheme,
    language,
    setLanguage,
    getThemeClasses,
    t
  };
  return <ThemeContext.Provider value={value} data-id="element-260" data-mp="pn0ulb5jj8qk">{children}</ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}